'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { PAGE_LABEL, PAGE_NAME, PageName } from '@/constants/navigation.constants';
import { useNavigationLogic } from '@/hooks/useNavigationLogic';
import TextButton from '@/shared/ui/atoms/TextButton';

const MobileNavigations = () => {
  const router = useRouter();
  const { pathname, appStoreId, hasToken, isOwnerOrAdmin, getNavigationItem } = useNavigationLogic();
  const [openDropdownIndex, setOpenDropdownIndex] = useState<number>(1);

  const checkPage = (page: PageName) => {
    return getNavigationItem(page, appStoreId) === pathname;
  };

  const setCurrentPage = () => {
    const dashboardPage = getNavigationItem(PAGE_NAME.DASHBOARD, appStoreId);
    const reviewsPage = getNavigationItem(PAGE_NAME.REVIEWS, appStoreId);
    const reviewBoosterLandingPage = getNavigationItem(PAGE_NAME.REVIEW_BOOSTER_LANDING, appStoreId);
    const reviewBoosterPage = getNavigationItem(PAGE_NAME.REVIEW_BOOSTER, appStoreId);
    const enterprisePage = getNavigationItem(PAGE_NAME.ENTERPRISE, appStoreId);
    const medicontentsLandingPage = getNavigationItem(PAGE_NAME.MEDICONTENTS_LANDING, appStoreId);
    const medicontentsPage = getNavigationItem(PAGE_NAME.MEDICONTENTS, appStoreId);

    if (pathname === '/' || pathname.includes(dashboardPage) || pathname.includes(reviewsPage) || pathname.includes(enterprisePage)) {
      setOpenDropdownIndex(1);
    } else if (pathname.includes(reviewBoosterLandingPage) || pathname.includes(reviewBoosterPage)) {
      setOpenDropdownIndex(2);
    } else if (pathname.includes(medicontentsLandingPage) || pathname.includes(medicontentsPage)) {
      setOpenDropdownIndex(3);
    } else {
      setOpenDropdownIndex(0);
    }
  };

  useEffect(() => {
    setCurrentPage();
  }, [pathname]);

  return (
    <nav className="flex flex-col gap-2">
      <div>
        <button onClick={() => setOpenDropdownIndex(1)} className="flex w-full items-center  py-[6px] text-start text-[#2E2F33] text-[20px] font-bold leading-[24px] tracking-[0.32px]">
          <span>리뷰매니저</span>
          {openDropdownIndex === 1 ? <KeyboardArrowUp className="text-[#2E2F33]" /> : <KeyboardArrowDown className="text-[#2E2F33]" />}
        </button>
        {openDropdownIndex === 1 && (
          <div className="flex flex-col py-[10px]">
            <TextButton
              label={PAGE_LABEL[PAGE_NAME.ENTERPRISE]}
              onClick={() => {
                router.push(getNavigationItem(PAGE_NAME.ENTERPRISE, appStoreId));
              }}
              className="py-[10px] px-[12px] text-start w-full text-[#333438] text-[16px] font-semibold leading-[24px] disabled:rounded-[4px] disabled:bg-[#F9FAFB]"
              disabled={checkPage(PAGE_NAME.ENTERPRISE)}
            />
            <TextButton
              label={PAGE_LABEL[PAGE_NAME.DASHBOARD]}
              onClick={() => {
                router.push(getNavigationItem(PAGE_NAME.DASHBOARD, appStoreId));
              }}
              className="py-[10px] px-[12px] text-start w-full text-[#333438] text-[16px] font-semibold leading-[24px] disabled:rounded-[4px] disabled:bg-[#F9FAFB]"
              disabled={checkPage(PAGE_NAME.DASHBOARD)}
            />
            <TextButton
              label={PAGE_LABEL[PAGE_NAME.REVIEWS]}
              onClick={() => {
                router.push(getNavigationItem(PAGE_NAME.REVIEWS, appStoreId));
              }}
              className="py-[10px] px-[12px] text-start w-full text-[#333438] text-[16px] font-semibold leading-[24px] disabled:rounded-[4px] disabled:bg-[#F9FAFB]"
              disabled={checkPage(PAGE_NAME.REVIEWS)}
            />
          </div>
        )}
      </div>

      <div>
        <button onClick={() => setOpenDropdownIndex(2)} className="flex w-full items-center py-[6px] text-start text-[#2E2F33] text-[20px] font-bold leading-[24px] tracking-[0.32px]">
          <span>리뷰부스터</span>
          {openDropdownIndex === 2 ? <KeyboardArrowUp className="text-[#2E2F33]" /> : <KeyboardArrowDown className="text-[#2E2F33]" />}
        </button>
        {openDropdownIndex === 2 && (
          <div className="flex flex-col py-[10px]">
            <TextButton
              label={PAGE_LABEL[PAGE_NAME.REVIEW_BOOSTER_LANDING]}
              onClick={() => {
                router.push(getNavigationItem(PAGE_NAME.REVIEW_BOOSTER_LANDING, appStoreId));
              }}
              className="py-[10px] px-[12px] text-start w-full text-[#333438] text-[16px] font-semibold leading-[24px] disabled:rounded-[4px] disabled:bg-[#F9FAFB]"
              disabled={checkPage(PAGE_NAME.REVIEW_BOOSTER_LANDING)}
            />
            {hasToken && (
              <TextButton
                label={PAGE_LABEL[PAGE_NAME.REVIEW_BOOSTER]}
                onClick={() => {
                  router.push(getNavigationItem(PAGE_NAME.REVIEW_BOOSTER, appStoreId));
                }}
                className="py-[10px] px-[12px] text-start w-full text-[#333438] text-[16px] font-semibold leading-[24px] disabled:rounded-[4px] disabled:bg-[#F9FAFB]"
                disabled={checkPage(PAGE_NAME.REVIEW_BOOSTER)}
              />
            )}
          </div>
        )}
      </div>

      <div>
        <button onClick={() => setOpenDropdownIndex(3)} className="flex w-full items-center py-[6px] text-start text-[#2E2F33] text-[20px] font-bold leading-[24px] tracking-[0.32px]">
          <span>메디컨텐츠</span>
          {openDropdownIndex === 2 ? <KeyboardArrowUp className="text-[#2E2F33]" /> : <KeyboardArrowDown className="text-[#2E2F33]" />}
        </button>
        {openDropdownIndex === 3 && (
          <div className="flex flex-col py-[10px]">
            <TextButton
              label={PAGE_LABEL[PAGE_NAME.MEDICONTENTS_LANDING]}
              onClick={() => {
                router.push(getNavigationItem(PAGE_NAME.MEDICONTENTS_LANDING, appStoreId));
              }}
              className="py-[10px] px-[12px] text-start w-full text-[#333438] text-[16px] font-semibold leading-[24px] disabled:rounded-[4px] disabled:bg-[#F9FAFB]"
              disabled={checkPage(PAGE_NAME.MEDICONTENTS_LANDING)}
            />
            {hasToken && (
              <TextButton
                label={PAGE_LABEL[PAGE_NAME.MEDICONTENTS]}
                onClick={() => {
                  router.push(getNavigationItem(PAGE_NAME.MEDICONTENTS, appStoreId));
                }}
                className="py-[10px] px-[12px] text-start w-full text-[#333438] text-[16px] font-semibold leading-[24px] disabled:rounded-[4px] disabled:bg-[#F9FAFB]"
                disabled={checkPage(PAGE_NAME.MEDICONTENTS)}
              />
            )}
          </div>
        )}
      </div>

      <TextButton
        label={PAGE_LABEL[PAGE_NAME.BLOG]}
        onClick={() => {
          router.push(getNavigationItem(PAGE_NAME.BLOG, appStoreId));
        }}
        className="text-start py-[6px] text-[#2E2F33] text-[20px] font-bold leading-[24px] tracking-[0.32px] cursor-pointer"
      />

      {hasToken && isOwnerOrAdmin && (
        <TextButton
          label={PAGE_LABEL[PAGE_NAME.ORGANIZATION]}
          onClick={() => {
            router.push(getNavigationItem(PAGE_NAME.ORGANIZATION, appStoreId));
          }}
          className="text-start py-[6px] text-[#2E2F33] text-[20px] font-bold leading-[24px] tracking-[0.32px] cursor-pointer"
          disabled={checkPage(PAGE_NAME.ORGANIZATION)}
        />
      )}
    </nav>
  );
};

export default MobileNavigations;
